import { defineMessages } from 'react-intl';

export default defineMessages({
  'high' : {
    'id' : 'priority_level.high.title',
    'defaultMessage' : 'High'
  },
  'medium' : {
    'id' : 'priority_level.medium.title',
    'defaultMessage' : 'Medium'
  },
  'low' : {
    'id' : 'priority_level.low.title',
    'defaultMessage' : 'Low'
  },
});